import { apiClient } from './client.js';

export interface CreatePaymentIntentResponse {
  stripeAccountId: string | null;
  clientSecret: string;
  customerSessionClientSecret: string | null;
}

export const paymentsApi = {
  createIntent: (bookingId: string, savePaymentMethod = false) =>
    apiClient.post<CreatePaymentIntentResponse>('/payments/intent', {
      bookingId,
      savePaymentMethod,
    }),
  createGroupIntent: (bookingGroupId: string, savePaymentMethod = false) =>
    apiClient.post<CreatePaymentIntentResponse>('/payments/intent', {
      bookingGroupId,
      savePaymentMethod,
    }),
};
